// extracted by mini-css-extract-plugin
export var acceptButton = "_3p-5";
export var fullContent = "_3p-4";
export var link = "_3p-6";
export var linkIcon = "_3p-7";
export var sideContent = "_3p-3";
export var sideImage = "_3p-2";
export var sideImageWrapper = "_3p-1";
export var splitLayout = "_3p-0";